import React from 'react'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import { IAlertProps } from './AlertComponent.types'
import { Container, ContainerText } from './styles'

const Alert: React.FC<IAlertProps> = ({
  message,
  type,
  description,
  textColor = colors.black,
  icon: Icon,
  colorIcon,
  backgroundColor,
}: IAlertProps) => {
  return (
    <Container type={type} backgroundColor={backgroundColor}>
      {Icon && <Icon style={{ color: colorIcon }} />}
      <ContainerText>
        <Text color={textColor}>{message}</Text>
        <Text color={textColor}>{description}</Text>
      </ContainerText>
    </Container>
  )
}

export default Alert
